module.exports = __webpack_public_path__ + "static/media/whatapps.2ac0a41e.png";